import { defineComponent as _defineComponent } from 'vue'
import type { YoutubePlayerOptions } from '@/interfaces/components/youtube-player';
import type { SnowplowContext } from '@/helpers/tracking/providers';
import { toValue, type MaybeRefOrGetter } from '@vueuse/core';

import NewDesignModal from '@/components/modals/NewDesignModal.vue';
import { useRoutingStore } from '@/helpers/composables/useStores';
import { ModalHelper } from '@/helpers/modal-helper';

import { computed, ref, watch } from 'vue';
import type { TrailerClip } from '@/interfaces/trailerClip';
import { getTrailerComponent } from '@/helpers/trailer-helper';
import { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import SponsoredRecommendation from '@/components/sponsored-recommendations/SponsoredRecommendation.vue';
import { SraPlacement } from '@/@types/graphql-types';


export default /*#__PURE__*/_defineComponent({
  __name: 'TrailerModal',
  props: {
    clips: null,
    titleName: null,
    source: { default: 'modal' },
    additionalContexts: { default: () => [] },
    sponsoredAd: null,
    sraPlacement: null
  },
  setup(__props: any) {

const props = __props as { clips: MaybeRefOrGetter<TrailerClip[]>, titleName: string, source: string, additionalContexts: SnowplowContext[], sponsoredAd?: SponsoredAdFragment | null, sraPlacement?: SraPlacement };



// For this placement, we play the SR video once, then display the trailer
const hasSrVideoPlayedOnce = ref(false);

const options: YoutubePlayerOptions = { autoplay: 1, mute: 1 };

const { activeRoute } = useRoutingStore();

watch(
	() => activeRoute,
	() => ModalHelper.close()
);

const trailerClip = computed(() => toValue(props.clips)[0]);

// Once SR videos played once, we can show the trailer
function handleTrailerVideoEnded(hasVideoEnded: boolean) {
	hasSrVideoPlayedOnce.value = hasVideoEnded;
}

const videoPlayer = computed(() => {
	return getTrailerComponent(trailerClip.value?.provider);
});

return { __sfc: true,props, hasSrVideoPlayedOnce, options, activeRoute, trailerClip, handleTrailerVideoEnded, videoPlayer, NewDesignModal, SponsoredRecommendation }
}

})